<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">已有的设备列表</span>
      </config-title-hang>


        <config-hang
          v-for="(value,index) in serveDeviceListData"
          :key="index"
          @click.native="oneDeviceBtnHandle(value.productName ,value.productId)"
        >
          <span slot="config_hang_ele2">{{value.productName}}</span>
          <span slot="config_hang_ele3">{{value.remark}}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />

        </config-hang>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";

export default {
  data() {
    return {
      serveDeviceListData: [
        //服务器请求到的设备列表
      ]
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang

  },
  methods: {
    oneDeviceBtnHandle(title , productId) {
      ////一个设备按钮被点击了
      this.$router.push({ path: "deviceDetails", query: { title: title , productId:productId} });
    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    // console.log("created阶段");
    /// 获取分类下产品列表接口，获取数据
    console.log(this.$route.query.typeId);

    this.$request({
      method: "post",
      url: "/product/findProductListByTypeId",
      data: {
        token: this.$store.state.token,
        typeId: this.$route.query.typeId   ///根据不同的设备类型获取不同类型的设备的数据列表
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style>
</style>